<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="isAuthenticated"
        @click="startLogout"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon class="ml-2">mdi-logout</v-icon>
        <span class="ml-2">{{ givenName }}</span>
      </v-btn>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapActions, mapGetters } = createNamespacedHelpers('authentication')
export default {
  name: 'LogoutButton',
  computed: {
    ...mapGetters(['isAuthenticated', 'user']),
    tooltip() {
      return `${this.user.division}-${this.user.role}`
    },
    givenName() {
      if (this.user.given_name) {
        return `${this.user.given_name} ${this.user.family_name}`
      }
      return this.user.ppid
    }
  },
  methods: {
    ...mapActions(['startLogout']),
    onLogout() {
      this.$auth.logout()
    }
  }
}
</script>

<style></style>
